import { render } from "./FormCompleteHeader.vue?vue&type=template&id=23076c66&scoped=true"
import script from "./FormCompleteHeader.vue?vue&type=script&lang=js"
export * from "./FormCompleteHeader.vue?vue&type=script&lang=js"

import "./FormCompleteHeader.vue?vue&type=style&index=0&id=23076c66&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/aclu-or-form/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23076c66"]])

export default __exports__